export default "<div style=\"border: 1px solid red\">error Component</div>\r\n";